// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"d016a3e5","761":"44f19384"}[chunkId] + ".chunk.js";
};